<!-- <router-outlet></router-outlet> -->
<app-header></app-header>
<div class="mainContent">
  <section class="accountInfo pt-4 l-gray">
    <div class="container-fluid">
      <div class="accountInfo-verticalNav">
        <div class="accountInfo-wrapper">
          <ul
            *ngIf="user$ | async as user; else userMenuLoading"
            ngbnav=""
            orientation="vertical"
            class="nav-pills nav flex-column bg-white"
            role="tablist"
          >
            <li class="userImgName">
              <div class="user-img">
                <img
                  [src]="
                    user.gender === 'MALE'
                      ? 'assets/images/male.png'
                      : 'assets/images/female.png'
                  "
                  alt=""
                />
              </div>
              <div class="user-name">
                <h2>{{ user.firstName }} {{ user.lastName }}</h2>
                <!-- <p>حساب منظم</p> -->
              </div>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                routerLinkActive="active"
                [routerLink]="['./personal-data']"
              >
                <i class="far fa-user"></i>
                {{ "my personal account" | translate }}
              </a>
            </li>
            <li class="nav-item" *ngIf="helpers.isUserEventCreator">
              <a
                class="nav-link"
                routerLinkActive="active"
                [routerLink]="['./company-info']"
              >
                <i class="fas fa-suitcase"></i>
                {{ "company information" | translate }}
              </a>
            </li>
            <!-- <li class="nav-item">
              <a
                class="nav-link"
                routerLinkActive="active"
                [routerLink]="['./invoices']"
              >
                <i class="fas fa-file-invoice-dollar"></i>
                {{ "Invoices" | translate }}
              </a>
            </li> -->
            <li class="nav-item">
              <a
                class="nav-link"
                routerLinkActive="active"
                [routerLink]="['./my-tickets']"
              >
                <i class="fas fa-file-invoice-dollar"></i>
                {{ "My Tickets" | translate }}
              </a>
            </li>
            <li ngbnavitem="signOut" class="nav-item">
              <a (click)="logout()" class="signOut nav-link">
                <i class="fas fa-sign-out-alt"> </i>
                <span>
                  {{ "sign out" | translate }}
                </span>
              </a>
            </li>
          </ul>
          <div class="tab-content">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<ng-template #userMenuLoading>
  <ul
    ngbnav=""
    orientation="vertical"
    class="nav-pills nav flex-column bg-white"
  >
    <li class="userImgName">
      <div class="user-img">
        <span class="skeleton-box skeleton-box__image"></span>
      </div>
      <div class="user-name">
        <h2>
          <span class="skeleton-box"></span>
        </h2>
        <p><span class="skeleton-box"></span></p>
      </div>
    </li>
    <li class="nav-item">
      <a href="#" class="nav-link"><span class="skeleton-box"></span></a>
    </li>
    <li class="nav-item">
      <a href="#" class="nav-link"><span class="skeleton-box"></span></a>
    </li>
    <li class="nav-item">
      <a href="#" class="nav-link"><span class="skeleton-box"></span></a>
    </li>
  </ul>
</ng-template>

<app-footer></app-footer>
